/**
 * Vertragsjahre im Frontend – dieselben Regeln wie `AbrechnungService` im Backend: ein Vertragsjahr
 * ist nach dem Kalenderjahr seines Beginns benannt und läuft vom Jahrestag der Unterschrift bis zum
 * Vortag im Folgejahr (Unterschrift 23.09.2026 → Vertragsjahr 2028 = 23.09.2028 – 22.09.2029).
 */

/** Jahrestag der Unterschrift im Kalenderjahr `jahr` (der 29.02. rutscht auf den 28.02.). */
export const jahrestag = (unterschrift: string, jahr: number): Date => {
  const [, m, d] = unterschrift.split('T')[0].split('-').map(Number);
  const tag = Math.min(d, new Date(Date.UTC(jahr, m, 0)).getUTCDate());
  return new Date(jahr, m - 1, tag);
};

export const fmtDatum = (d: Date): string =>
  `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;

/**
 * Das laufende Vertragsjahr, benannt nach dem Kalenderjahr seines Beginns – dieselbe Regel wie
 * `AbrechnungService.laufendesVertragsjahr` im Backend. Vor dem ersten Jahrestag ist es das
 * Unterschriftsjahr.
 */
export const laufendesVertragsjahr = (unterschrift: string, heute: Date = new Date()): number => {
  const start = Number(unterschrift.slice(0, 4));
  const jahr = jahrestag(unterschrift, heute.getFullYear()) > heute ? heute.getFullYear() - 1 : heute.getFullYear();
  return Math.max(jahr, start);
};

/** "23.09.2027 – 22.09.2028" für das Vertragsjahr, das in `jahr` beginnt. */
export const vertragsjahrText = (unterschrift: string, jahr: number): string => {
  const von = jahrestag(unterschrift, jahr);
  const naechster = jahrestag(unterschrift, jahr + 1);
  // Vortag über das Kalenderdatum, nicht „minus 24 Stunden“: an der Sommerzeit-Umstellung hat ein
  // Tag nur 23 Stunden, und der Vortag wäre dann zwei Tage früher.
  const bis = new Date(naechster.getFullYear(), naechster.getMonth(), naechster.getDate() - 1);
  return `${fmtDatum(von)} – ${fmtDatum(bis)}`;
};
